"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_admin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "ab0a95bd-103d-46b9-9b27-56a6ded50284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ddb4537f-f0f4-4fd7-99d1-01df89115799"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_196b83ce-2f4b-458c-9872-ffeaf58b8ff1",
    "data-name": "196b83ce-2f4b-458c-9872-ffeaf58b8ff1",
    cx: 96,
    cy: 62,
    r: 36,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_872ed8c5-510e-479e-9e49-28aed3c3f33a",
    "data-name": "872ed8c5-510e-479e-9e49-28aed3c3f33a",
    d: "M154,166c-6.48-43.73-31.53-68-58-68s-51.51,24.27-58,68",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#676767",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }))));
}

var _default = ic_admin;
exports.default = _default;